module.exports = __webpack_public_path__ + "static/media/aniket_ware.3cb0afb7.png";